"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    wrapper: function (_a) {
        var theme = _a.theme, spacing = _a.spacing, variant = _a.variant;
        return ({
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: variant === 'vertical' ? 'column' : 'row',
            margin: (theme_1.getSizeValue({ sizes: theme.spacing, size: spacing }) / 2) * -1,
            marginTop: (theme_1.getSizeValue({ sizes: theme.spacing, size: spacing }) / 4) *
                (variant === 'vertical' ? 1 : -1),
            '& [data-mantine-radio]': {
                margin: theme_1.getSizeValue({ sizes: theme.spacing, size: spacing }) / 2,
                marginTop: variant === 'vertical' && theme_1.getSizeValue({ sizes: theme.spacing, size: spacing }) / 4,
                marginBottom: variant === 'vertical' && theme_1.getSizeValue({ sizes: theme.spacing, size: spacing }) / 4,
            },
        });
    },
}, { link: true });
